export const SELECT_TAB = 'tabs/SELECT_TAB';
export const SELECT_NESTED_TAB = 'tabs/SELECT_NESTED_TAB';